import React, { useState, useEffect, useCallback, useRef } from "react";
import Box from "@mui/material/Box";
import TopHeader from "../../Component/Header/TopHeader";
import "../../style/css/journalForm.css";
import {
  useGetAllMemberListMutation,
  useEnableDisableMemberListMutation, useApproveRejectMemberMutation,
  useDeleteMemberListMutation
} from "../../app/services/memberListServices";
import {
  useLazyGetChapterDetailsByIdQuery,
} from "../../app/services/chapterServices";
import Table from "@mui/material/Table";
import { InputAdornment, Modal, TextField, FormControlLabel, Tabs, Grid, RadioGroup, Radio, FormHelperText, Divider, } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Container, IconButton, Checkbox, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import ReactPaginate from "react-paginate";
import '../../style/css/pagination.css'; // Import CSS file for pagination styles
import { toast } from "react-toastify";
import Spinner from "../../Component/spinner/spinner"
import Tooltip from "@mui/material/Tooltip";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useLazyGetSIGGroupByIdQuery } from "../../app/services/SIGGroupServices";
import Tab from '@mui/material/Tab';
import { useForm, Controller } from "react-hook-form";
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyIcon from '@mui/icons-material/Key';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "../../app/services/loginServices";
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAddNotPaidMemberMutation, useSearchMemberMutation, useUpdateChangePlanMutation, useUpdatePlansRenewalMutation } from "../../app/services/memberServices";
import { useLazyGetAllMemberShipDetailsQuery, useLazyGetMemberShipDetailsByIdQuery } from "../../app/services/memberShipServices";
import { planType } from "../../constant/constant";
import { selectCurrentScope } from "../../app/auth/authSlice";
import { useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close'

const ChapterName = ({ id }) => {
  const [chapterDetails, setChapterDetails] = useState(null);
  const [getChapterDetailsById] = useLazyGetChapterDetailsByIdQuery();

  useEffect(() => {
    getChapterDetailsById(id)
      .unwrap()
      .then((res) => {
        setChapterDetails(res.data);
      })
      .catch((error) => {
        console.error("Error fetching chapter details:", error);
      });
  }, [id, getChapterDetailsById]);
  return chapterDetails ? chapterDetails?.title : '-----';
};

const SigName = ({ id }) => {
  const [sigDetails, setSigDetails] = useState(null);
  const [getSigDetailById] = useLazyGetSIGGroupByIdQuery()
  useEffect(() => {
    getSigDetailById(id)
      .unwrap()
      .then((res) => {
        setSigDetails(res.data);
      })
      .catch((error) => {
        console.error("Error fetching sig details:", error);
      });
  }, [id, getSigDetailById]);
  return sigDetails ? sigDetails.groupName : '-----';
};
function EnhancedTableHead({ type }) {
  let headCells
  if (type === '0' || type === '1' || type === undefined || type === null || type === '' || type === "4") {
    headCells = [
      {
        id: "memberId",
        numeric: false,
        disablePadding: true,
        label: "Member ID",
      },
      {
        id: "Name",
        numeric: false,
        disablePadding: true,
        label: "Name",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
        width: '100px !important'
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
        width: '100px !important'
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '280px !important' },
    ];
  }
  else if (type === '2') {
    headCells = [
      {
        id: "memberId",
        numeric: false,
        disablePadding: true,
        label: "Member ID",
      },
      {
        id: "Institution",
        numeric: false,
        disablePadding: true,
        label: "Name",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
        width: '100px !important'
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
        width: '100px !important'
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '280px !important' },
    ];
  } else if (type === '3') {
    headCells = [
      {
        id: "memberId",
        numeric: false,
        disablePadding: true,
        label: "Member ID",
      },
      {
        id: "Organisation",
        numeric: false,
        disablePadding: true,
        label: "Name",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
        width: '100px !important'
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
        width: '100px !important'
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '280px !important' },
    ];
  }

  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells && headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff", minWidth: headCell.width ? headCell.width : 'auto' }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}

function RejectTableHead({ type }) {
  let headCells
  if (type === '0' || type === '1' || type === undefined || type === null || type === '' || type === '4') {
    headCells = [
      {
        id: "Name",
        numeric: false,
        disablePadding: true,
        label: "Name",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      {
        id: "Reject Reason",
        numeric: false,
        disablePadding: true,
        label: "Reject Reason",
      },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '250px !important' },
    ];
  }
  else if (type === '2') {
    headCells = [
      {
        id: "Institution",
        numeric: false,
        disablePadding: true,
        label: "Institution",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      {
        id: "Reject Reason",
        numeric: false,
        disablePadding: true,
        label: "Reject Reason",
      },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '250px !important' },
    ];
  } else if (type === '3') {
    headCells = [
      {
        id: "Organisation",
        numeric: false,
        disablePadding: true,
        label: "Organisation",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: true,
        label: "Email ID",
      },
      {
        id: "phoneNumber",
        numeric: false,
        disablePadding: true,
        label: "Phone Number",
      },
      {
        id: "chapter",
        numeric: false,
        disablePadding: true,
        label: "Chapter",
      },
      {
        id: "SIG",
        numeric: false,
        disablePadding: true,
        label: "SIG",
      },
      // {
      //   id: "Address",
      //   numeric: false,
      //   disablePadding: true,
      //   label: "Address",
      // },
      {
        id: "Reject Reason",
        numeric: false,
        disablePadding: true,
        label: "Reject Reason",
      },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions", width: '250px !important' },
    ];
  }


  return (
    <>
      <TableHead>
        <TableRow className="menus-color">
          {headCells && headCells.map((headCell) => (
            <TableCell
              sx={{ textAlign: "center", color: "#ffff", minWidth: headCell.width ? headCell.width : 'auto' }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "normal"}
            >
              {headCell.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    </>
  );
}
const style1 = {
  position: "absolute",
  top: "55%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 600,
  minWidth: 550,
  height: '50%',
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: 4,
  overflowY: 'scroll',
  "&::-webkit-scrollbar": {
    display: 'none'
  },
};

const GetPlanDetails = ({ id, typeId, value }) => {
  const [getPlanById] = useLazyGetMemberShipDetailsByIdQuery();
  const [plan, setPlan] = useState(null);
  const [planTypes, setPlanTypes] = useState(null);
  useEffect(() => {
    getPlanById(id).then(res => {
      setPlan(res?.data?.data)
      setPlanTypes(res?.data?.data?.planType)
    })
  }, [getPlanById, id])
  if (value === 'plan') {
    return <>{planType.find(item => item.planId === plan?.planName)?.planName}</>
  }
  if (value === 'planType') {
    const pt = planTypes?.find(item => item._id === typeId);
    return <>{pt?.planTypeName}{pt ? `(${pt.duration}${pt.duration > 1 ? ' Years' : ' Year'})` : ''}</>
  }
}
export default function AllMemberList() {
  const [loading, setLoading] = useState(true);
  const [getAll, setGetAll] = useState([]);
  const [page, setPage] = useState(0);//state for set page
  const [finalFormData, setFinalFormData] = useState('')
  const [pendingMemberPage, setPendingMemberPage] = useState(0);
  const [rejectionMemberPage, setRejectionMemberPage] = useState(0)
  const [notPaidMemberPage, setNotPaidMemberPage] = useState(0)
  let [pendingMembertotalCount, setPendingMemberTotalCount] = useState(0);
  const [rejectionMemberTotel, setRejectionMemberTotel] = useState(0)
  const [notPaidMemberTotel, setNotPaidMemberTotel] = useState(0)
  let [totalCount, setTotalCount] = useState(0);
  const [getAllMemberList] = useGetAllMemberListMutation();
  const [type, setType] = useState('');
  const [value, setTabValue] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  // const [getAllPendingMemberlist] = useGetAllPendingMemberMutation()
  const [getAllPendingMembers, setGetAllPendingMembers] = useState([])
  const [showButton, setShowButton] = useState(false)
  const [approveRejectMember] = useApproveRejectMemberMutation()
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [rejection, setRejection] = useState([])
  const [notPaid, setNotPaid] = useState([])
  const navigate = useNavigate()
  const [open1, setOpen1] = useState(false)
  const [memberRejected, setMemberRejected] = useState(null)
  const [resetPassword] = useResetPasswordMutation();
  const [addNotPaidMember] = useAddNotPaidMemberMutation()
  const [openForm, setOpenForm] = useState(false);
  const [openChangeForm, setOpenChangeForm] = useState(false);
  const [searchMemberApi] = useSearchMemberMutation()
  const [getPlanById] = useLazyGetMemberShipDetailsByIdQuery()
  const [getAllPlans] = useLazyGetAllMemberShipDetailsQuery()
  const [updateMemberRenewal] = useUpdatePlansRenewalMutation()
  const [memberPlanChange] = useUpdateChangePlanMutation()
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [error, setError] = useState("");
  const [selectedMember, setSelectedMember] = useState(null)
  const [deleteMember] = useDeleteMemberListMutation();
  const [previousFormData, setPreviousFormData] = useState(null);
  // const [updateMemberRenewal] = useUpdatePlansRenewalMutation()
  const [getSigDetailById] = useLazyGetSIGGroupByIdQuery()
  const [getChapterDetailsById] = useLazyGetChapterDetailsByIdQuery();
  const memberScope = useSelector(selectCurrentScope)
  const [skipApiCall, setSkipApiCall] = useState(false);
  const skipNextApiCall = useRef(false);
  const [changePlanType, setChangePlanType] = useState([]);
  const [allPlans, setAllplans] = useState([])

  useEffect(() => {
    getAllPlans().then(res => {
      if (res?.data?.status) {
        setAllplans(res?.data?.data)
      }
    })
  }, [getAllPlans])

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: 300,
    maxWidth: 600,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "5px",
    p: 4,
  };

  const handleChange = (event, newValue) => {
    if (newValue === 3) {
      setType('');
    }
    setError('')
    setTabValue(newValue);
  };

  const handleClose = () => {
    setOpen(false)
    setOpen1(false);
    reset({ rejectionReason: "" });
  }

  const handleDeleteModalClose = () => {
    setOpenDelete(false)
  }
  const handleDeleteModalOpen = (member) => {
    setSelectedMember(member)
    setOpenDelete(true)
  }

  const downloadPdf = () => {
    const data = {
      searchBy: finalFormData.searchBy ? Number(finalFormData.searchBy) : '',
      searchTerm: finalFormData.searchTerm || '',
      type: type,
      page: 1,
      itemsPerPage: ''
    };
    searchMemberApi(data).then(res => {
      setLoading(false);

      if (res?.data?.status) {
        // setGetAll(res.data?.data?.memberDetails || []);
        setTotalCount(res.data?.data?.totalCount || 0);
        let sigIds = [];
        let chapterIds = [];
        let sigName = new Array(res.data?.data?.memberDetails.length).fill(null).map(() => []);
        let chapterNames = new Array(res.data?.data?.memberDetails.length).fill("");

        Promise.all(
          res.data?.data?.memberDetails.map((item, index) => {
            sigIds.push(item.sigGroups);
            chapterIds.push(item.chapter);

            const chapterPromise = item.chapter
              ? getChapterDetailsById(item.chapter).then(res => {
                chapterNames[index] = res?.data?.data?.title;
              })
              : Promise.resolve();

            const sigGroupPromise = Promise.all(
              item.sigGroups?.map(id =>
                id ? getSigDetailById(id).then(res => res.data.data.groupName) : Promise.resolve("")
              )
            ).then(groupNames => {
              sigName[index] = groupNames;
            });

            return Promise.all([chapterPromise, sigGroupPromise]);
          })
        ).then(() => {
          // Ensure CSV is generated after data is ready
          generateCsv(res.data?.data?.memberDetails, sigName, chapterNames);
        }).catch(err => console.error("Error fetching data:", err));
      } else {
        setGetAll([]);
      }
    });
  };


  const generateCsv = (members, sigName, chapterNames) => {
    if (!Array.isArray(members) || members.length === 0) {
      console.error("Invalid data: Expected an array of members");
      return;
    }

    // Specify only the keys you need in the CSV
    const includedKeys = [
      "salutation", "fullName", "gender", "dateOfBirth", "email", "mobileNumber", "institution", "designation",
      "plans", "educationalQualification", "studying", "course",
      "whatsAppMessage", "emailMessage", "typeOfInstitution", "institutionEstablished", "organisationName", "organisationEstablished", "websiteAddressOrganisation", "typeOfOrganisation", "employees", "headOfficeLocated",
      "websiteAddressInstitution", "studentsInInstitution", "teachersInInstitution", "isPaid",
      "paymentType", "type", "sigGroups", "chapter", "isApproved",
    ];

    const headerMapping = includedKeys.reduce((acc, key) => {
      acc[key] = key
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/^(\w)/, match => match.toUpperCase());
      return acc;
    }, {});

    const formattedHeaders = Object.values(headerMapping).map(h => `"${h}"`);

    const csvRows = members.map((member, index) => {
      const formattedMember = {
        ...member,
        sigGroups: sigName[index]?.join(", ") || "",
        chapter: chapterNames[index] || "",
        studying: member.studying === 0 ? "UG" : member.studying === 1 ? "PG" : member.studying === 2 ? "M.Phill." : member.studying === 2 ? "Ph.D." : '',
        course: member.course || "",
        websiteAddressInstitution: member.websiteAddressInstitution,
        teachersInInstitution: member.teachersInInstitution,
        studentsInInstitution: member.studentsInInstitution,
        institutionEstablished: member.institutionEstablished,
        typeOfInstitution: member.typeOfInstitution === 1 ? "Government" : member.typeOfInstitution === 2 ? "Government - Aided" : member.typeOfInstitution === 3 ? "Private" : '',
        organisationName: member.organisationName || '',
        websiteAddressOrganisation: member.websiteAddressOrganisation || '',
        organisationEstablished: member.organisationEstablished || '',
        typeOfOrganisation: member.typeOfOrganisation === 1 ? "Government" : member.typeOfOrganisation === 2 ? "Private" : member.typeOfOrganisation === 3 ? "Non-Profit" : '',
        employees: member.employees || '',
        headOfficeLocated: member.headOfficeLocated || '',
        designation: member.designation || '',
        institutionName: member.institution || '',
        plans: member.plans.map(plan => `${plan.planTypeName}`),
        // plans: member.plans.map(plan => `${plan.planId} (${plan.planTypeId})`).join(" | "),
        educationalQualification: member.educationalQualification.join(", "),
        dateOfBirth: member?.dateOfBirth?.split('T')[0] || "",
        gender: member.gender === 0 ? 'Male' : member.gender === 1 ? 'Female' : '',
        isPaid: member.isPaid === 0 ? 'Unpaid' : 'Paid',
        whatsAppMessage: member.whatsAppMessage === 0 ? 'No' : member.whatsAppMessage === 1 ? 'Yes' : '',
        emailMessage: member.emailMessage === 0 ? 'No' : 'Yes',
        salutation: member.salutation === 0 ? 'Mr' :
          member.salutation === 1 ? 'Ms' :
            member.salutation === 2 ? 'Mx' :
              member.salutation === 3 ? 'Dr' : member.salutation === 4 ? 'Prof' : '',
        paymentType: member.paymentType === 0 ? 'Cash' :
          member.paymentType === 1 ? 'Online' : 'Cheque',
        type: member.type === '0' ? 'Individual Teacher' :
          member.type === '1' ? 'Individual Student' :
            member.type === '2' ? 'Educational Institution' :
              member.type === '3' ? 'Corporates' : 'Dual Member',
        isApproved: member.isApproved === 0 ? 'Pending' :
          member.isApproved === 1 ? 'Approved' :
            member.isApproved === 2 ? 'Rejected' :
              member.isApproved === 3 ? 'Error or failure payment' : 'Not Payment'
      };

      return includedKeys.map(key => `"${formattedMember[key] || ""}"`).join(",");
    });

    // Combine headers and rows
    const csvData = [formattedHeaders.join(","), ...csvRows].join("\n");

    // Create a Blob and trigger download
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "members_data.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };



  const handleDeleteMember = () => {
    deleteMember(selectedMember?._id).then(res => {
      if (res?.data?.status)
        toast?.success(res?.data?.message)
      handleDeleteModalClose();
      if (getAll.length === 1) {
        setPage(page - 1)
        fetchDataByTab(value);
      }
      else {
        fetchDataByTab(value);
      }
    })
  }
  const handleView = (member) => {
    if (member.type === "0" || member.type === "4") {
      navigate(`/admin/teacher-member/${member._id}`);
    } else if (member.type === "1") {
      navigate(`/admin/student-member/${member._id}`);
    } else if (member.type === "2") {
      navigate(`/admin/View-institution/${member._id}`);
    } else {
      navigate(`/admin/view-corporate/${member._id}`);
    }
  }
  const {
    register: registerReject,
    getValues,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      rejectionReason: ''
    }, mode: 'onChange'
  });

  const {
    control: controlSearch,
    register: registerSearch,
    watch: watchSearch,
    clearErrors: clearErrorsSearch,
    reset: resetSearch,
    handleSubmit,
    setValue: setValueSearch,
    formState: { errors: searchErrors },
  } = useForm({
    mode: 'onChange', defaultValues: {
      searchTerm: '',
      searchBy: '0',
    }
  });

  const {
    control: controlAdd,
    register: registerAdd,
    handleSubmit: handleSubmitAdd,
    setValue: setValueAdd,
    watch: watchAdd,
    reset: resetAdd,
    formState: { errors: errorsAdd, dirtyFields: dirtyFieldsAdd },
    clearErrors: nonPaidClearError
  } = useForm({
    mode: "onChange",
    defaultValues: {
      memberId: "",
      paymentType: 0,  // cash: 0, online: 1, cheque: 2
      paymentMethod: "",
      bankTransactionId: "",
      amount: "",
      currency: "0",
      scope: memberScope ? memberScope : '',
    },
  });
  const {
    control: controlChange,
    register: registerChange,
    handleSubmit: handleSubmitChange,
    setValue: setValueChange,
    watch: watchChange,
    reset: resetChange,
    formState: { errors: errorsChange, dirtyFields: dirtyFieldsChange },
    clearErrors: clearErrorChange
  } = useForm({
    mode: "onChange",
    defaultValues: {
      memberId: "",
      paymentType: 0,  // cash: 0, online: 1, cheque: 2
      paymentMethod: "",
      bankTransactionId: "",
      planId: '',
      planType: '',
      amount: "",
      currency: "0",
      scope: memberScope ? memberScope : '',
    },
  });

  const handleFormClose = () => {
    setOpenForm(false)
    resetAdd({
      memberId: "",
      paymentType: 0,  // cash: 0, online: 1, cheque: 2
      paymentMethod: "",
      bankTransactionId: "",
      amount: "",
      currency: "0",
      scope: memberScope ? memberScope : "", // Ensure scope is updated

    })
  }
  const handleChangeFormClose = () => {
    setOpenChangeForm(false)
    resetChange({
      memberId: "",
      paymentType: 0,  // cash: 0, online: 1, cheque: 2
      paymentMethod: "",
      bankTransactionId: "",
      amount: "",
      currency: "0",
      scope: memberScope ? memberScope : "", // Ensure scope is updated
    })
  }
  const isWithinDateRange = (sDate, eDate) => {
    const startDate = new Date(sDate);
    const endDate = new Date(eDate);
    const today = new Date();

    // Strip time part for an accurate date-only comparison (optional)
    const start = new Date(startDate.toDateString());
    const end = new Date(endDate.toDateString());
    const now = new Date(today.toDateString());

    const isWithinRange = now >= start && now <= end;
    return isWithinRange;
  };
  const handleOpenForm = (row) => {
    setOpenForm(true);
    const planAmount = row?.plans[row?.plans?.length - 1];
    let offerAmount;
    let discountAmount;
    getPlanById(planAmount?.dummyPlanId).then(res => {
      const plan = res?.data?.data
      const planDetail = res.data?.data?.planType?.find(item => item._id === row?.plans[row?.plans?.length - 1]?.dummyPlanTypeId)
      const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(planAmount?.planEndDate)
      offerAmount = planDetail?.offer > 0 ? planDetail?.offerAmount : 0;
      discountAmount = planDetail?.discount > 0 ? planDetail?.discountAmount : 0;
      setValueAdd('originalAmount', planDetail?.amount)
      setValueAdd('currency', planDetail?.currencyType ? String(planDetail.currencyType) : "")
      if (value === 0) {
        setValueAdd("amount", (!planExpired && discountAmount > 0 && isWithinDateRange(plan?.startDate, plan?.endDate)) ? discountAmount : offerAmount > 0 ? offerAmount : planDetail?.amount, { shouldDirty: false, shouldValidate: true });
      }
      else {
        setValueAdd("amount", offerAmount > 0 ? offerAmount : planDetail?.amount, { shouldDirty: false, shouldValidate: true });
      }
    })

    setValueAdd("memberId", row?._id);
    setValueAdd('membershipPlan', row?.plans[row?.plans?.length - 1].dummyPlanId)
    setValueAdd('membershipPlanType', row?.plans[row?.plans?.length - 1].dummyPlanTypeId)
    setValueAdd("scope", memberScope ? memberScope : ""); // Update scope dynamically
  }
  const handleOpenChangeForm = (row) => {
    setOpenChangeForm(true);
    const planAmount = row?.plans.findLast(pl => pl.isPaid === 1);
    getPlanById(planAmount?.dummyPlanId).then(res => {
      const plan = res?.data?.data
      const planType = res.data?.data?.planType?.filter(item => item._id !== row?.plans.findLast(pl => pl.isPaid === 1)?.dummyPlanTypeId && (item?.planTypeName !== 'Annual' && item?.planTypeName !== 'Annual Plan'))
      setValueChange('planId', plan)
      setChangePlanType(planType)
    })
    setValueChange("memberId", row?._id);
  }
  const changePlan = (data) => {
    setLoading(true)
    const payload = dirtyFieldsChange.amount ? {
      amount: watchChange('amount'),
      currency: watchChange('currency'),
      plans: [
        {
          "planId": watchChange('planId')._id,
          "planTypeId": watchChange('planType'),
        }
      ],
      paymentType: watchChange('paymentType'),
      paymentMethod: watchChange('paymentMethod'),
      memberId: watchChange('memberId'),
      bankTransactionId: watchChange('bankTransactionId') || ''
    } : {
      plans: [
        {
          "planId": watchChange('planId')._id,
          "planTypeId": watchChange('planType'),
        }
      ],
      paymentType: watchChange('paymentType'),
      paymentMethod: watchChange('paymentMethod'),
      memberId: watchChange('memberId'),
      bankTransactionId: watchChange('bankTransactionId') || ''
    }

    memberPlanChange({ id: watchChange('memberId'), data: payload }).then(res => {
      setLoading(false)
      if (res?.data?.status) {
        resetChange({})
        fetchDataByTab(value);
        handleChangeFormClose();
        toast.success(res?.data?.message)
      }
      else {
        toast.error(res.data?.err?.message)
      }
    })
  }
  const AddMember = (data) => {
    addNotPaidMember(data).then(res => {
      if (res.data?.status) {
        toast.success(res.data?.message)
        setLoading(false);
        setOpenForm(false)
        setNotPaidMemberPage(0)
        resetAdd({
          memberId: "",
          paymentType: 0,  // cash: 0, online: 1, cheque: 2
          paymentMethod: "",
          bankTransactionId: "",
          amount: "",
          currency: "0",
        })
        getAllNotPaidPagination()
      }
      else {
        setLoading(false);
        setOpenForm(false)
        toast.error(res.data?.err?.message)
      }
    })

  }

  const handleCheckboxToggle = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id)
        ? prev.filter((rowId) => rowId !== id) // If id is already selected, remove it
        : [...prev, id] // If id is not selected, add it
    );
  };

  const handleSelectAll = (e) => {
    const checked = e.target.checked; // Get the checkbox state (true or false)
    setShowButton(checked)
    // Update selectedRows based on whether the checkbox is checked
    setSelectedRows(checked ? getAllPendingMembers.map((row) => row._id) : []);
  };
  // Check if a row is selected

  // Optionally log selectedRows for debugging
  useEffect(() => {
    if (selectedRows.length > 0) {
      setShowButton(false)
    }
  }, [selectedRows]);
  const showButtons = selectedRows.length > 0;
  const shouldShowButtons = showButton || showButtons;

  //get change value
  const getChangeValue = (eve) => {
    const value = eve.target.value
    setPage(0)
    setPendingMemberPage(0)
    setRejectionMemberPage(0)
    setNotPaidMemberPage(0)
    setType(value === 'All' ? '' : value);
    // getAllPagination(eve.target.value);
    setLoading(true)
    setSelectedRows([])
    setValueSearch('searchTerm', '')
  };

  // const getChangeValues = (eve) => {

  //   const types = eve.target.value
  //   console.log(types, "jkbn")
  //   setSkipApiCall(true);
  //   setType((type) => type = types === 'All' ? '' : types)
  //   console.log(type, "setType")

  // }

  // const searchMember = useCallback((formData) => {
  //   console.log(formData)
  //   if (skipApiCall) {
  //     setSkipApiCall(false); 
  //     return;
  //   }

  //   // setPage(0)
  //   const finalFormData = formData || previousFormData || {};
  //   setFinalFormData(formData || previousFormData || {})

  //   if (formData) {
  //     setPreviousFormData(formData); // Store the latest form data
  //   }
  //   setLoading(true);
  //   const data = {
  //     searchBy: finalFormData.searchBy ? Number(finalFormData.searchBy) : '',
  //     searchTerm: finalFormData.searchTerm || '',
  //     type: type,
  //     page: page + 1,
  //     itemsPerPage: itemsPerPage
  //   };
  //   console.log("data", data)
  //  if (data.earchTerm &&data.type){

  //  }
  //   searchMemberApi(data).then(res => {
  //     setLoading(false);

  //     if (res?.data?.status) {
  //       setGetAll(res.data?.data?.memberDetails || []);
  //       setTotalCount(res.data?.data?.totalCount || 0);

  //       let sigIds = [];
  //       let chapterIds = [];
  //       let sigName = new Array(res.data?.data?.memberDetails.length).fill(null).map(() => []);
  //       let chapterNames = new Array(res.data?.data?.memberDetails.length).fill("");

  //       Promise.all(
  //         res.data?.data?.memberDetails.map((item, index) => {
  //           sigIds.push(item.sigGroups);
  //           chapterIds.push(item.chapter);

  //           const chapterPromise = item.chapter
  //             ? getChapterDetailsById(item.chapter).then(res => {
  //               chapterNames[index] = res.data.data.title;
  //             })
  //             : Promise.resolve();


  //           const sigGroupPromise = Promise.all(
  //             item.sigGroups?.map((id) =>
  //               id ? getSigDetailById(id).then(res => res.data.data.groupName) : Promise.resolve("")
  //             )
  //           ).then((groupNames) => {
  //             sigName[index] = groupNames;
  //           });

  //           return Promise.all([chapterPromise, sigGroupPromise]);
  //         })
  //       ).then(() => {
  //         setSigNames(sigName);
  //         setChapterNames(chapterNames);
  //       }).catch((err) => console.error("Error fetching data:", err));
  //     } else {
  //       setGetAll([]);
  //     }
  //   });

  // }, [searchMemberApi, page, type ,itemsPerPage]);



  const searchMember = useCallback((formData) => {
    if (skipNextApiCall.current) {
      skipNextApiCall.current = false; // ✅ Reset the flag after skipping
      return;
    }
    const finalFormData = formData || previousFormData || {};
    setFinalFormData(finalFormData);

    if (formData) {
      setPreviousFormData(formData);
    }

    setLoading(true);

    const data = {
      searchBy: finalFormData.searchBy ? Number(finalFormData.searchBy) : '',
      searchTerm: finalFormData.searchTerm || '',
      type: formData?.type ?? type,
      page: page + 1,
      itemsPerPage
    };

    searchMemberApi(data).then(res => {
      setLoading(false);

      if (res?.data?.status) {
        setGetAll(res.data?.data?.memberDetails || []);
        setTotalCount(res.data?.data?.totalCount || 0);

        let sigIds = [];
        let chapterIds = [];
        let sigName = new Array(res.data?.data?.memberDetails.length).fill(null).map(() => []);
        let chapterNames = new Array(res.data?.data?.memberDetails.length).fill("");

        Promise.all(
          res.data?.data?.memberDetails.map((item, index) => {
            sigIds.push(item.sigGroups);
            chapterIds.push(item.chapter);

            const chapterPromise = item.chapter
              ? getChapterDetailsById(item.chapter).then(res => {
                chapterNames[index] = res.data.data.title;
              })
              : Promise.resolve();

            const sigGroupPromise = Promise.all(
              item.sigGroups?.map((id) =>
                id ? getSigDetailById(id).then(res => res.data.data.groupName) : Promise.resolve("")
              )
            ).then((groupNames) => {
              sigName[index] = groupNames;
            });

            return Promise.all([chapterPromise, sigGroupPromise]);
          })
        ).then(() => {
        }).catch((err) => console.error("Error fetching data:", err));
      } else {
        setGetAll([]);
      }
    });
  }, [searchMemberApi, getChapterDetailsById, getSigDetailById, page, itemsPerPage, type, previousFormData]);

  // ✅ Handle search button click
  const handleSearch = (data) => {
    searchMember(data);
  };

  // ✅ Handle dropdown value change
  const getChangeValues = (eve) => {
    const newType = eve.target.value === 'All' ? '' : eve.target.value;
    skipNextApiCall.current = true; // ✅ Ensure next effect skips API call
    setType(newType);
  };

  // ✅ useEffect triggers API only when needed
  useEffect(() => {
    if (skipNextApiCall.current) {
      skipNextApiCall.current = false; // ✅ Reset flag after skipping
      return;
    }
    searchMember();
  }, [type, searchMember]);

  const handleOpen1 = (member) => {
    setOpen1(true);
    setMemberRejected(member)
  };


  const getAllPendingPagination = useCallback(
    (types) => {
      const resolvedType = (types === undefined && (type === null || type === undefined)) ? '0' : types ? types : type // Explicit check
      const data = {
        page: pendingMemberPage + 1,
        itemsPerPage: itemsPerPage,
        type: resolvedType,
        approve: 0,
      };

      setLoading(true);
      getAllMemberList(data)
        .then((response) => {
          setGetAllPendingMembers(response.data?.data?.memberDetails || []);
          setPendingMemberTotalCount(response.data?.data?.totalCount || 0);
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [getAllMemberList, type, pendingMemberPage, itemsPerPage]
  );

  const getAllRejectionPagination = useCallback((types) => {
    const resolvedType = (types === undefined && (type === null || type === undefined)) ? '0' : types ? types : type
    var data = {
      page: rejectionMemberPage + 1,
      itemsPerPage: itemsPerPage,
      approve: 2,
      type: resolvedType
    }
    getAllMemberList(data).then((response) => {
      setLoading(false);
      setRejection(response.data?.data?.memberDetails || []);
      setRejectionMemberTotel(response.data?.data?.totalCount || 0);

    })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  }, [getAllMemberList, type, rejectionMemberPage, itemsPerPage])


  const getAllNotPaidPagination = useCallback((types) => {
    const resolvedType = (types === undefined && (type === null || type === undefined)) ? '0' : types ? types : type // Simplified type resolution
    var data = {
      page: notPaidMemberPage + 1,
      itemsPerPage: itemsPerPage,
      approve: 4,
      type: resolvedType,
    }
    getAllMemberList(data).then((response) => {
      setLoading(false);
      setNotPaid(response.data?.data?.memberDetails || []);
      setNotPaidMemberTotel(response.data?.data?.totalCount || 0);
    })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
      });
  }, [getAllMemberList, type, notPaidMemberPage, itemsPerPage])

  const NotPaidPageCount = Math.ceil(notPaidMemberTotel / itemsPerPage);
  useEffect(() => {
    if (skipApiCall) {
      setSkipApiCall(false); // ✅ Reset after skipping
      return;
    }

    switch (value) {
      case 0:
        if (type === '') {
          searchMember();
        }
        break;
      case 1:
        getAllPendingPagination();
        break;
      case 2:
        getAllRejectionPagination();
        break;
      case 3:
        getAllNotPaidPagination();
        break;
      default:
        console.warn("Unhandled tab value:", value);
    }
  }, [value, searchMember, getAllPendingPagination, getAllNotPaidPagination, getAllRejectionPagination, type, skipApiCall]);

  const handleNotPaidPageClick = ({ selected }) => {
    setNotPaidMemberPage(selected);
  };

  function PendingTableHead() {
    let headCells
    const handleSelectAllCheckbox = (e) => handleSelectAll(e);
    if (type === '0' || type === '1' || type === undefined || type === null || type === '' || type === '4') {

      headCells = [
        {
          id: "select",
          numeric: false,
          disablePadding: true,
          label: (
            <Checkbox
              inputProps={{ 'aria-label': 'Select All Rows' }}
              onChange={handleSelectAllCheckbox}  // Correctly pass the event
              checked={selectedRows.length === getAllPendingMembers.length} // Select All if all rows are selected
            />
          ),
        },
        {
          id: "Name",
          numeric: false,
          disablePadding: true,
          label: "Name",
        },
        {
          id: "email",
          numeric: false,
          disablePadding: true,
          label: "Email ID",
        },
        {
          id: "phoneNumber",
          numeric: false,
          disablePadding: true,
          label: "Phone Number",
        },
        {
          id: "chapter",
          numeric: false,
          disablePadding: true,
          label: "Chapter",
        },
        {
          id: "SIG",
          numeric: false,
          disablePadding: true,
          label: "SIG",
        },
        // {
        //   id: "Address",
        //   numeric: false,
        //   disablePadding: true,
        //   label: "Address",
        // },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ];
    }
    else if (type === '2') {
      headCells = [
        {
          id: "select",
          numeric: false,
          disablePadding: true,
          label: (
            <Checkbox
              inputProps={{ 'aria-label': 'Select All Rows' }}
              onChange={handleSelectAllCheckbox}  // Correctly pass the event
              checked={selectedRows.length === getAllPendingMembers.length} // Select All if all rows are selected
            />
          ),
        },
        {
          id: "Institution",
          numeric: false,
          disablePadding: true,
          label: "Institution",
        },
        {
          id: "email",
          numeric: false,
          disablePadding: true,
          label: "Email ID",
        },
        {
          id: "phoneNumber",
          numeric: false,
          disablePadding: true,
          label: "Phone Number",
        },
        {
          id: "chapter",
          numeric: false,
          disablePadding: true,
          label: "Chapter",
        },
        {
          id: "SIG",
          numeric: false,
          disablePadding: true,
          label: "SIG",
        },
        // {
        //   id: "Address",
        //   numeric: false,
        //   disablePadding: true,
        //   label: "Address",
        // },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ];
    } else if (type === '3') {
      headCells = [
        {
          id: "select",
          numeric: false,
          disablePadding: true,
          label: (
            <Checkbox
              inputProps={{ 'aria-label': 'Select All Rows' }}
              onChange={handleSelectAllCheckbox}  // Correctly pass the event
              checked={selectedRows.length === getAllPendingMembers.length} // Select All if all rows are selected
            />
          ),
        },
        {
          id: "Organisation",
          numeric: false,
          disablePadding: true,
          label: "Organisation",
        },
        {
          id: "email",
          numeric: false,
          disablePadding: true,
          label: "Email ID",
        },
        {
          id: "phoneNumber",
          numeric: false,
          disablePadding: true,
          label: "Phone Number",
        },
        {
          id: "chapter",
          numeric: false,
          disablePadding: true,
          label: "Chapter",
        },
        {
          id: "SIG",
          numeric: false,
          disablePadding: true,
          label: "SIG",
        },
        // {
        //   id: "Address",
        //   numeric: false,
        //   disablePadding: true,
        //   label: "Address",
        // },
        { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
      ];
    }

    return (
      <>
        <TableHead>
          <TableRow className="menus-color">
            {headCells && headCells.map((headCell) => (
              <TableCell
                sx={{ textAlign: "center", color: "#ffff" }}
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
              >
                {headCell.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      </>
    );
  }

  //handlepage
  const handlePageClick = ({ selected }) => {
    setSearchTerm('')
    setError("");
    setPage(selected);
  };
  const handlePendingPageClick = ({ selected }) => {
    setPendingMemberPage(selected);
  };
  const handleRejectPageClick = ({ selected }) => {
    setRejectionMemberPage(selected);
  };
  //calculate page count
  const pageCount = Math.ceil(totalCount / itemsPerPage);
  const pendingPageCount = Math.ceil(pendingMembertotalCount / itemsPerPage);
  const RejectPageCount = Math.ceil(rejectionMemberTotel / itemsPerPage);

  const handlePageChange = () => {

    const pageNumber = Number(searchTerm);
    if (isNaN(pageNumber) || pageNumber < 0) {
      setError("Page number cannot be less than 1");
    } else if (pageNumber > pageCount) {
      setError("Please enter valid page number");
    } else if (pageNumber === 0) {
      setError("Please enter page number");
    } else {
      setError("");
      setPage(pageNumber - 1);
    }
  };


  const [isEnabledDisabled] = useEnableDisableMemberListMutation();

  //handlrtoggle
  const handleToggle = (user) => {
    const id = user._id;

    if (!id) {
      console.warn("Invalid user ID");
      return;
    }

    setLoading(true);

    isEnabledDisabled(id)
      .unwrap()
      .then((response) => {
        setLoading(false);

        if (response?.status) {
          const isEnabled = response?.data?.isDeleted === 0;
          toast[isEnabled ? "success" : "error"](
            isEnabled ? "Member Enabled" : "Member Disabled"
          );

          // Handle fetching data based on the current tab
          fetchDataByTab(value);
        } else {
          toast.error(response?.err?.message || "An error occurred");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.message || "An unexpected error occurred");
      });
  };

  // Reusable function to fetch data based on the active tab
  const fetchDataByTab = (tabValue) => {
    switch (tabValue) {
      case 0:
        searchMember();
        break;
      case 1:
        getAllPendingPagination();
        break;
      case 2:
        getAllRejectionPagination();
        break;
      case 3:
        getAllNotPaidPagination();
        break;
      default:
        console.warn("Unhandled tab value:", tabValue);
    }
  };

  const handleApproveReject = async (type) => {
    if (type === 1) {
      const isValid = await trigger("rejectionReason"); // Trigger validation manually
      if (!isValid) {
        return; // Do not proceed if validation fails
      }
    }

    const rejectionReason = getValues("rejectionReason");
    const data = {
      membersId: selectedRows,
      type,
      ...(type === 1 && { rejectionReason }),
    };

    approveRejectMember(data)
      .then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message);
          fetchDataByTab(value);
          handleClose();
          getAllPendingPagination()
          if (type === 1) {
            reset({ rejectionReason: "" }); // Clear the input field
          }
        } else {
          toast.error("Something went wrong");
        }
      })
      .catch((err) => {
        console.error(err);
      });
    setSelectedRows([]); // Clear selected rows
  };

  const handleResetPassword = (member) => {
    var data = {
      id: member._id,
      role: "PORTAL_MEMBER"
    }
    resetPassword(data).then((res) => {
      if (res?.data?.status) {
        toast.success(res?.data?.message);
      }
      else {
        toast.error(res?.data?.message)
      }
    }).catch(err => console.error(err))
  }
  const handleOpen = () => {
    setOpen(true);
  }

  // const searchMember = (formData) => {
  //   setLoading(true)
  //   const data = {
  //     "searchBy": Number(formData.searchBy),
  //     "searchTerm": formData.searchTerm,
  //     "type": type,
  //     "page": Page,
  //     "itemsPerPage": itemsPerPage
  //   }
  //   searchMemberApi(data).then(res => {
  //     setLoading(false)
  //     if (res?.data?.status) {
  //       setGetAll(res?.data?.data);
  //       setTotalCount(0);
  //     }
  //     else {
  //       setGetAll([])
  //     }
  //   }, [searchMemberApi, page, itemsPerPage])
  // }
  const resetTable = () => {
    const data = { searchBy: '0', searchTerm: '' }
    setType('')
    setPage(0)
    // searchTerm()
    searchMember(data)
    resetSearch(data)
    // resetSearch(data)

    fetchDataByTab(value)
  }
  const renewMember = (data) => {
    resetAdd({})
    // setLoading(true)
    if (dirtyFieldsAdd.amount) {
    }
    else {
      delete data.amount;
    }
    const payload = data;
    updateMemberRenewal(payload).then(res => {
      setLoading(false)
      if (res?.data?.status) {
        fetchDataByTab(value);
        handleFormClose();
        toast.success(res?.data?.message)
      }
      else {
        toast.error(res?.data?.err)
      }
    })
  }

  function isDateWithinThreeMonths(dateToCompare) {
    const today = new Date();
    const oneMonthsLater = new Date(today);
    oneMonthsLater.setMonth(today.getMonth() + 1);
    const date = new Date(dateToCompare.split('T')[0]);
    oneMonthsLater.setDate(date.getDate());
    return date >= oneMonthsLater;
  }

  function showChangeButton(row) {
    const plan = row?.plans.findLast(pl => pl.isPaid === 1)
    const memberPlanType = allPlans.find(pl => pl?._id === plan?.planId)?.planType.find(ty => ty?._id === plan?.planTypeId)
    const planTypes = allPlans.find(pl => pl?._id === plan?.planId)?.planType.filter(ty => ty?._id !== plan?.planTypeId)
    const show = (planTypes && planTypes.length >= 1) && (planTypes.some(ty => ty?.duration > memberPlanType?.duration) || new Date().setHours(0, 0, 0, 0) > new Date(plan?.planEndDate))
    return show
  }

  return (
    <>
      <TopHeader />
      <div className="pt-5 mb-4">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">Member List</h2>
        </div>
      </div>
      <Container maxWidth="xl" className=" p-md-5 p-3  overallPadding">
        <Grid
          container
          spacing={2}
          style={{
            maxWidth: '100%',
            margin: "0 auto",
            position: "sticky",
            top: "0",
            zIndex: "999",
            marginBlock: "10px",
          }}
        >
          <Tabs
            position="static"
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons
            allowScrollButtonsMobile
            textColor='#611f1e'
            sx={{
              // borderRadius: "8px",
              backgroundColor: '#611f1e !important',
              mx: 'auto',
              width: '100%',
              display: 'flex',
              flexGrow: "1",
              "& .MuiButtonBase-root": {
                color: "white",  // Change the color of the scroll buttons
              }
            }}
          >
            <Tab
              label="All Members"
              sx={{
                width: '25%',
                maxWidth: '100%',
                color: value === 0 ? '#611f1e !important' : 'white',
                background: value === 0 ? 'white' : '#611f1e !important',
              }}
            />
            <Tab
              label="Pending Members"
              sx={{
                width: '25%',
                maxWidth: '100%',
                color: value === 1 ? '#611f1e !important' : 'white',
                background: value === 1 ? 'white' : '#611f1e !important',
              }}
            />
            <Tab
              label="Rejected Members"
              sx={{
                width: '25%',
                maxWidth: '100%',
                color: value === 2 ? '#611f1e !important' : 'white',
                background: value === 2 ? 'white' : '#611f1e !important',
              }}
            />
            <Tab
              label="Unpaid Members"
              sx={{
                width: '25%',
                maxWidth: '100%',
                color: value === 3 ? '#611f1e !important' : 'white',
                background: value === 3 ? 'white' : '#611f1e !important',
              }}
            />
          </Tabs>
        </Grid>
        {loading ? (
          <Spinner />
        ) : (
          <>
            {value === 0 && (
              <>
                <form onSubmit={handleSubmit(handleSearch)} className="mt-3 p-3">
                  <Grid container rowSpacing={3} columnSpacing={3} className="d-flex justify-content-start">
                    <Grid item xs={12} md={12} lg={5}>
                      <Controller
                        control={controlSearch}
                        name={`searchBy`}
                        rules={{ required: 'Please select a option' }}
                        render={({ field, fieldState }) => (
                          <>
                            <FormControl fullWidth>
                              <RadioGroup
                                row
                                value={field.value}
                                className="d-flex flex-sm-row flex-column mx-auto"
                                onChange={(event) => {
                                  const selectedValue = event.target.value;
                                  field.onChange(selectedValue);
                                  clearErrorsSearch('searchTerm')
                                }}
                              >
                                <FormControlLabel
                                  value="0"
                                  control={<Radio />}
                                  label={'Name'}
                                />
                                <FormControlLabel
                                  value="1"
                                  control={<Radio />}
                                  label={'Member ID'}
                                />
                                <FormControlLabel
                                  value="2"
                                  control={<Radio />}
                                  label={'Mail ID'}
                                />
                                <FormControlLabel
                                  value="3"
                                  control={<Radio />}
                                  label={'Mobile Number'}
                                />
                              </RadioGroup>
                              {fieldState?.error && (
                                <FormHelperText error>
                                  {fieldState.error.message}
                                </FormHelperText>
                              )}
                            </FormControl>
                          </>
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4} lg={2}>
                      <FormControl className="w-100">
                        <InputLabel shrink={true} id="type-label" sx={{
                          '&.Mui-focused': {
                            color: 'inherit', // Maintain the default color
                          },
                        }}>Type</InputLabel>
                        <Select
                          labelId="type-label"
                          id="type"
                          label="type"
                          required
                          fullWidth
                          value={type === '' ? 'All' : type}
                          onChange={getChangeValues}
                          sx={{
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'inherit', // Maintain the default border color
                            },
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'inherit', // Prevent border change on hover
                            },
                            '& .MuiOutlinedInput-input': {
                              paddingInline: '7px !important', // Adjust label padding
                              paddingBlock: '8px !important', // Adjust label padding
                            }
                          }}
                        //   sx={{
                        //     '& .MuiOutlinedInput-input': {
                        //         paddingInline: '7px !important', // Adjust label padding
                        //         paddingBlock: '8px !important', // Adjust label padding
                        //     },
                        // }}
                        >
                          <MenuItem value='All'>All</MenuItem>
                          <MenuItem value={'0'}> Individual Teacher </MenuItem>
                          <MenuItem value={'4'}>Dual Teacher </MenuItem>
                          <MenuItem value={'1'}>  Individual Student </MenuItem>
                          <MenuItem value={'2'}>  Institutional </MenuItem>
                          <MenuItem value={'3'}>Corporate Supporter </MenuItem>
                        </Select>
                      </FormControl>
                      {shouldShowButtons && value === 1 &&
                        <div >
                          <button className="btn btn-danger" onClick={handleOpen}>Reject</button>
                          <button className="btn btn-primary ms-2" onClick={() => handleApproveReject(0)} style={{ backgroundColor: "#611f1e", border: 'none' }}>Approve</button>
                        </div>
                      }
                    </Grid>
                    <Grid item xs={12} md={8} lg={5} className="d-flex justify-content-between flex-sm-row flex-column align-items-start gap-3">
                      <TextField
                        label={
                          <Typography className="text-dark" >
                            {/* Search Term <span className="text-danger">*</span> */}
                            Search Term
                          </Typography>
                        }
                        sx={{
                          '& .MuiOutlinedInput-input': {
                            paddingInline: '7px !important', // Adjust label padding
                            paddingBlock: '8px !important', // Adjust label padding
                          },
                        }}
                        InputLabelProps={{ shrink: true }}
                        value={watchSearch('searchTerm') || ''}
                        placeholder="Enter a search term"
                        {...registerSearch('searchTerm', {
                          // required: 'Please enter a search term',
                          minLength: { value: 3, message: 'Please enter a valid search term' },
                          pattern: {
                            value: (watchSearch('searchBy') === '2' || watchSearch('searchBy') === 2) ?
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ : false,
                            message: "Enter a valid email ID",
                          }, validate: (value) => {
                            if (watchSearch('searchBy') === "1" || watchSearch('searchBy') === 1) {
                              return (value.length < 10 || value.length > 10) ? 'Member ID must be 10 character alphanumeric value' : true
                            }
                            if (watchSearch('searchBy') === "3" || watchSearch('searchBy') === 3) {
                              const regex = /^\d{10}$/;
                              return !regex.test(value) ? 'Please enter a valid mobile number' : true
                            }
                            return true
                          }
                        })}
                        fullWidth
                        error={!!searchErrors?.searchTerm}
                        helperText={searchErrors?.searchTerm?.message} />
                      <div className="d-flex ms-sm-0 ms-auto gap-2">
                        <Button type="submit" variant="contained" className="ms-auto menus-color"  >Search</Button>
                        <Button variant="outlined" color="error" className="rounded-0" onClick={resetTable}>Reset</Button>
                      </div>
                    </Grid>
                  </Grid>
                </form>
              </>
            )}
            {(value !== 0 && value !== 3) && <div className="mt-5 w-100 d-flex justify-content-between">
              <FormControl>
                <InputLabel shrink={true} id="type-label" sx={{
                  '&.Mui-focused': {
                    color: 'inherit', // Maintain the default color
                  },
                }}>Type</InputLabel>
                <Select
                  labelId="type-label"
                  id="type"
                  label="type"
                  required
                  fullWidth
                  value={type === '' ? 'All' : type}
                  onChange={getChangeValue}
                  sx={{
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'inherit', // Maintain the default border color
                    },
                    minWidth: '300px',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'inherit', // Prevent border change on hover
                    },
                  }}
                >
                  <MenuItem value='All'>All</MenuItem>
                  <MenuItem value={'0'}> Individual Teacher </MenuItem>
                  <MenuItem value={'4'}>Dual Teacher </MenuItem>
                  <MenuItem value={'1'}>  Individual Student </MenuItem>
                  <MenuItem value={'2'}>  Institutional </MenuItem>
                  <MenuItem value={'3'}>Corporate Supporter </MenuItem>
                </Select>
              </FormControl>
              {shouldShowButtons && value === 1 &&
                <div >
                  <button className="btn btn-danger" onClick={handleOpen}>Reject</button>
                  <button className="btn btn-primary ms-2" onClick={() => handleApproveReject(0)} style={{ backgroundColor: "#611f1e", border: 'none' }}>Approve</button>
                </div>
              }

            </div>}
            {value === 3 &&
              <div className="mt-5 w-100 d-flex justify-content-between">
                <FormControl>
                  <InputLabel shrink={true} id="type-label" sx={{
                    '&.Mui-focused': {
                      color: 'inherit', // Maintain the default color
                    },
                  }}>Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type"
                    label="type"
                    required
                    fullWidth
                    value={type === '' ? 'All' : type}
                    onChange={getChangeValue}
                    sx={{
                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'inherit', // Maintain the default border color
                      },
                      minWidth: '300px',
                      '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: 'inherit', // Prevent border change on hover
                      },
                    }}
                  >
                    <MenuItem value='All'>All</MenuItem>
                    <MenuItem value={'2'}>  Institutional </MenuItem>
                    <MenuItem value={'3'}>Corporate Supporter </MenuItem>
                  </Select>
                </FormControl>
                {shouldShowButtons && value === 1 &&
                  <div >
                    <button className="btn btn-danger" onClick={handleOpen}>Reject</button>
                    <button className="btn btn-primary ms-2" onClick={() => handleApproveReject(0)} style={{ backgroundColor: "#611f1e", border: 'none' }}>Approve</button>
                  </div>
                }
              </div>
            }
            {value === 0 && <Box sx={{ width: "100%" }} className="mt-3">

              <Paper sx={{ width: "100%", mb: 2 }}>
                <div className="float-end mb-2">
                  <Button onClick={() => downloadPdf()} variant="contained" className="ms-auto menus-color" >Download</Button>
                </div>
                <TableContainer>
                  <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                    <EnhancedTableHead type={type} />
                    <TableBody>
                      {getAll.length > 0 ? (
                        getAll.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">{row?.userId}</TableCell>
                            <TableCell align="center">{row.fullName ? row.fullName : row.organisationName ? row.organisationName : row.institution ? row.institution : '---'}</TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">{row.mobileNumber}</TableCell>
                            <TableCell align="center">
                              {row.chapter?.length > 0 ? <ChapterName id={row.chapter} /> : <p className="text-dark">---</p>}
                            </TableCell>
                            <TableCell align="center">
                              {row.sigGroups?.length > 0 ? row?.sigGroups.map((sig, idx) => (
                                <>
                                  <SigName id={sig} key={idx} />{idx !== row?.sigGroups?.length - 1 && ', '}
                                </>
                              )) : <p className="text-dark">---</p>}
                            </TableCell>
                            {/* <TableCell align="center" style={{ width: '200px', textOverflow: 'ellipsis', textWrap: 'wrap' }}>{row?.address},&nbsp;{row?.city},&nbsp;{row?.pinCode}.</TableCell> */}
                            <TableCell align="center">
                              <IconButton onClick={() => handleView(row)}>
                                <Tooltip title="View" placement="left">
                                  <VisibilityIcon style={{ color: '#ff8000' }} />
                                </Tooltip>
                              </IconButton>

                              <IconButton onClick={() => handleResetPassword(row)}>
                                <Tooltip title="Reset Password" placement="top">
                                  <KeyIcon style={{ color: 'darkred' }} />
                                </Tooltip>
                              </IconButton>
                              <IconButton onClick={() => handleToggle(row)}>
                                {row.isDeleted === 0 ? (
                                  <Tooltip title="Enable" placement="top">
                                    <LockOpenIcon style={{ color: 'green' }} />
                                  </Tooltip>

                                ) : (
                                  <Tooltip title="Disable" placement="top">
                                    <LockIcon style={{ color: 'red' }} />
                                  </Tooltip>

                                )}
                              </IconButton>
                              {(memberScope === 'PORTAL_SUPER_ADMIN' && (row?.plans.length > 0 && !isDateWithinThreeMonths(row?.plans[row?.plans.length - 1]?.planEndDate ? row?.plans[row?.plans.length - 1]?.planEndDate.split('T')[0] : ''))) && !(row?.userId.startsWith('A') && row?.plans[row?.plans.length - 1].planTypeName === 'Annual') && <IconButton onClick={() => { handleOpenForm(row) }}>
                                <Tooltip title="Renew Membership plan" placement="top">
                                  <AutorenewIcon className="text-warning" />
                                </Tooltip>
                              </IconButton>}
                              {memberScope === 'PORTAL_SUPER_ADMIN' && showChangeButton(row) && <IconButton onClick={() => { handleOpenChangeForm(row); setSelectedMember(row) }}>
                                <Tooltip title="Change Membership plan" placement="top">
                                  <RefreshIcon className="text-info" />
                                </Tooltip>
                              </IconButton>}
                              {memberScope === 'PORTAL_SUPER_ADMIN' && <IconButton onClick={() => { handleDeleteModalOpen(row) }}>
                                <Tooltip title="Delete Member" placement="top">
                                  <DeleteIcon className="text-danger" />
                                </Tooltip>
                              </IconButton>}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            Will Be Added Shortly
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              {getAll.length > 0 ? (
                <div className="d-flex justify-content-between flex-lg-row flex-column gx-3 gx-lg-0 content-font" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                  <div className="mb-2 mb-md-0">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        placeholder="Page no."
                        value={searchTerm}
                        onChange={(e) => {
                          const page = e.target.value ? Math.max(1, Number(e.target.value)) : "";
                          setSearchTerm(page);
                        }}
                        min={1}
                        className="search-input"
                      />
                      <div className="goPage cursor-pointer" onClick={handlePageChange}>
                        <h5 className="p-2 m-0">Go</h5>
                      </div>
                    </div>
                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                  </div>
                  <div className="my-3 my-lg-0">
                    <ReactPaginate
                      pageCount={pageCount} // Replace with the total number of pages
                      pageRangeDisplayed={1}
                      marginPagesDisplayed={1}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      disabledClassName={"disablebtn"}
                      forcePage={page}
                      previousLabel={pageCount > 1 && page >= 1 ? "Previous" : null}
                      nextLabel={pageCount > 1 && page + 1 !== pageCount ? "Next" : null}
                    />
                  </div>
                  <div className="mb-2 mb-md-0 content-font">
                    <FormControl variant="outlined">
                      <InputLabel></InputLabel>
                      <Select
                        className="itemsperpage"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItemsPerPage(value);
                          setError('')
                          setSearchTerm('');
                          setPage(0)
                        }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              ) : (<></>)}
            </Box>}
            {value === 1 && <Box sx={{ width: "100%" }} className="mt-3">
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                  <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                    <PendingTableHead />
                    <TableBody>
                      {getAllPendingMembers.length > 0 ? (
                        getAllPendingMembers.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">
                              <Checkbox
                                checked={selectedRows.includes(row._id)}
                                onChange={() => handleCheckboxToggle(row._id)}
                                inputProps={{ 'aria-label': 'Select Row' }}
                              />
                            </TableCell>
                            <TableCell align="center">{row.fullName ? row.fullName : row.organisationName ? row.organisationName : row.institution ? row.institution : '---'}</TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">{row.mobileNumber}</TableCell>
                            <TableCell align="center">
                              {row.chapter?.length > 0 ? <ChapterName id={row.chapter} /> : <p className="text-dark">---</p>}
                            </TableCell>
                            <TableCell align="center">
                              {row.sigGroups?.length > 0 ? row.sigGroups.map((sig, i) => (
                                <>
                                  <SigName id={sig} />{i > row.sigGroups?.length - 1 ? ',' : ''} <br />
                                </>
                              )) : <p className="text-dark">---</p>}
                            </TableCell>
                            {/* <TableCell align="center">{row.address},&nbsp;{row.city},&nbsp;{row.pinCode}.</TableCell> */}
                            <TableCell align="center">
                              <IconButton onClick={() => handleView(row)}>
                                <Tooltip title="View" placement="left">
                                  <VisibilityIcon style={{ color: '#ff8000' }} />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={8} align="center">
                            Will Be Added Shortly
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>


                  </Table>
                </TableContainer>
              </Paper>
              {getAllPendingMembers.length > 0 ? (
                <div className="d-flex justify-content-between flex-lg-row flex-column gx-3 gx-lg-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                  <div className="mb-2 mb-md-0">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        placeholder="Page no."
                        value={searchTerm}
                        // onChange={(e) => setSearchTerm(e.target.value)}
                        // onChange={(e) => setSearchTerm(Number(e.target.value - 1))}
                        onChange={(e) => {
                          const page = e.target.value ? Math.max(1, Number(e.target.value)) : "";
                          setSearchTerm(page);
                        }}
                        min={1}
                        className="search-input"
                      />
                      <div className="goPage cursor-pointer" onClick={handlePageChange}>
                        <h5 className="p-2 m-0">Go</h5>
                      </div>
                    </div>
                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                  </div>
                  <div className="my-3 my-lg-0">
                    <ReactPaginate
                      pageCount={pendingPageCount} // Replace with the total number of pages
                      pageRangeDisplayed={1}
                      marginPagesDisplayed={1}
                      onPageChange={handlePendingPageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                      disabledClassName={"disablebtn"}
                      forcePage={pendingMemberPage}
                      previousLabel={pendingPageCount > 1 && pendingMemberPage >= 1 ? "Previous" : null}
                      nextLabel={pendingPageCount > 1 && pendingMemberPage + 1 !== pendingPageCount ? "Next" : null}
                    />
                  </div>
                  <div className="mb-2 mb-md-0">
                    <FormControl variant="outlined">
                      <InputLabel></InputLabel>
                      <Select
                        className="itemsperpage"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItemsPerPage(value);
                          setError('')
                          setSearchTerm('');
                          setPage(0)
                        }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              ) : (<></>)}
            </Box>}
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >

              <Box sx={style} className="d-flex align-items-center flex-column gap-3">
                <Box className="d-flex justify-content-between flex-column pt-2 w-100">
                  <div className="d-flex justify-content-between">
                    <Typography variant="h5" className="fw-bold" sx={{ color: "#0d4022 !important", fontWeight: "bold" }}>
                      Rejection Reason
                    </Typography>
                    <IconButton onClick={handleClose} aria-label="Close">
                      <CloseIcon />
                    </IconButton>
                  </div>
                  <Box display="flex" justifyContent="center" width="100%" className='mb-2'>
                    <Divider className="w-100 mt-0" sx={{ bgcolor: "black", height: "2px" }} />
                  </Box>
                </Box>
                <TextField
                  fullWidth
                  inputProps={{ maxLength: 300 }}
                  label={
                    <Typography className="text-dark">
                      Reason For Rejection <span style={{ color: "red" }}>*</span>
                    </Typography>
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {300 - (watch("rejectionReason")?.length || 0)}
                      </InputAdornment>
                    ),
                  }}
                  error={!!errors?.rejectionReason}
                  helperText={errors?.rejectionReason?.message}
                  {...registerReject("rejectionReason", {
                    required: "Reason for rejection is required.",
                    maxLength: {
                      value: 300,
                      message: "Reason cannot exceed 300 characters.",
                    },
                  })}
                />
                <Box className="mt-3">
                  <Button variant="outlined" color="error" onClick={handleClose}>
                    Cancel
                  </Button>
                  <Button
                    className="mx-2"
                    variant="contained"
                    color="success"
                    onClick={() => handleApproveReject(1)}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            </Modal>
            {/* <Modal
              open={openDelete}
              onClose={handleDeleteModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style} className="d-flex align-items-center flex-column gap-3">
                <Typography variant="h4" sx={{ color: "#104e29" }}>
                  Delete Member
                </Typography>
                <Typography >
                  Are You sure you want to delete member <span className="text-secondary-new"> {selectedMember?.fullName ? selectedMember.fullName : selectedMember?.organisationName ? selectedMember?.organisationName : selectedMember?.institution ? selectedMember?.institution : ''} </span> ?
                </Typography>

                <Box className="mt-3">
                  <Button variant="outlined" color="error" onClick={handleDeleteModalClose}>
                    No
                  </Button>
                  <Button
                    className="mx-2"
                    variant="contained"
                    color="success"
                    onClick={() => handleDeleteMember()}
                  >
                    Yes
                  </Button>
                </Box>
              </Box>
            </Modal> */}
            <Modal
              open={openDelete}
              onClose={handleDeleteModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                className="d-flex  flex-column gap-3 overflow-x-hidden overflow-y-hidden"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  maxWidth: 500,
                  minWidth: 300,
                  backgroundColor: 'white',
                  boxShadow: 24,
                  padding: "20px",
                  outline: 'none',
                }}
              >
                <Box style={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h5" sx={{ color: "#0d4022", fontWeight: "bold" }}>
                    Confirmation
                  </Typography>
                  <IconButton onClick={handleDeleteModalClose} aria-label="Close">
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box display="flex" justifyContent="center" width="100%">
                  <Divider className="black-line-for-modal mb-0" sx={{ width: "100%" }} />
                </Box>
                <Typography
                  id="modal-modal-title"
                  style={{ color: "#611f1e" }}
                  variant="h6"
                  component="h2"
                  className="content-font"
                >
                  Are you sure you want to delete member <span className="text-secondary-new"> {selectedMember?.fullName ? selectedMember.fullName : selectedMember?.organisationName ? selectedMember?.organisationName : selectedMember?.institution ? selectedMember?.institution : ''} </span> ?
                </Typography>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="outlined"
                    style={{
                      color: "#dc3545",
                      border: "1px solid #dc3545",
                      padding: "5px 15px",
                      borderRadius: "0px",
                    }}
                    onClick={handleDeleteModalClose}
                  >
                    No
                  </Button>
                  <Button
                    className="mx-2"
                    variant="contained"
                    style={{
                      backgroundColor: "#2e7d32",
                      //  border: "1px solid #2e7d32",
                      color: "white",
                      padding: "5px 15px",
                      borderRadius: "0px",
                    }}
                    onClick={() => handleDeleteMember()}
                  >
                    Yes
                  </Button>
                </div>
              </Box>
            </Modal>
            {value === 2 && <Box sx={{ width: "100%" }} className="mt-3">
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                  <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                    <RejectTableHead />
                    <TableBody>
                      {rejection.length > 0 ? (
                        rejection.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">
                              {row.fullName || row.organisationName || row.institution || "---"}
                            </TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">{row.mobileNumber}</TableCell>
                            <TableCell align="center">
                              {row.chapter?.length > 0 ? (
                                <ChapterName id={row.chapter} />
                              ) : (
                                <p className="text-dark">---</p>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {row.sigGroups?.length > 0 ? (
                                row.sigGroups.map((sig, index) => (
                                  <span key={index}>
                                    <SigName id={sig} />
                                    {index < row.sigGroups.length - 1 && <br />}
                                  </span>
                                ))
                              ) : (
                                <p className="text-dark">---</p>
                              )}
                            </TableCell>
                            {/* <TableCell align="center">
                              {row.address}, {row.city}, {row.pinCode}.
                            </TableCell> */}
                            <TableCell align="center">
                              {row.rejectionReason ? (
                                <p
                                  onClick={() => handleOpen1(row)}
                                  className="text-primary text-decoration-underline"
                                >
                                  {row.rejectionReason.slice(0, 20)}...
                                </p>
                              ) : (
                                "-----"
                              )}
                            </TableCell>
                            <TableCell align="center">
                              <IconButton onClick={() => handleView(row)}>
                                <Tooltip title="View" placement="left">
                                  <VisibilityIcon style={{ color: '#ff8000' }} />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            Will Be Added Shortly
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
              {rejection.length > 0 ? (
                <div className="d-flex justify-content-between flex-lg-row flex-column gx-3 gx-lg-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                  <div className="mb-2 mb-md-0">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        placeholder="Page no."
                        value={searchTerm}
                        // onChange={(e) => setSearchTerm(e.target.value)}
                        // onChange={(e) => setSearchTerm(Number(e.target.value - 1))}
                        onChange={(e) => {
                          const page = e.target.value ? Math.max(1, Number(e.target.value)) : "";
                          setSearchTerm(page);
                        }}
                        min={1}
                        className="search-input"
                      />
                      <div className="goPage cursor-pointer" onClick={handlePageChange}>
                        <h5 className="p-2 m-0">Go</h5>
                      </div>
                    </div>
                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                  </div>
                  <div className="my-3 my-lg-0">
                    <ReactPaginate
                      pageCount={RejectPageCount}
                      pageRangeDisplayed={1}
                      marginPagesDisplayed={1}
                      onPageChange={handleRejectPageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                      disabledClassName="disablebtn"
                      forcePage={rejectionMemberPage}
                      previousLabel={RejectPageCount > 1 && rejectionMemberPage >= 1 ? "Previous" : null}
                      nextLabel={RejectPageCount > 1 && rejectionMemberPage + 1 !== RejectPageCount ? "Next" : null}
                    />
                  </div>
                  <div className="mb-2 mb-md-0">
                    <FormControl variant="outlined">
                      <InputLabel></InputLabel>
                      <Select
                        className="itemsperpage"
                        value={itemsPerPage}
                        onChange={(e) => {
                          const value = e.target.value;
                          setItemsPerPage(value);
                          setError('')
                          setSearchTerm('');
                          setPage(0)
                        }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              ) : (<></>)}
              <Modal
                open={open1}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} className="d-flex align-items-center flex-column gap-3">
                  <Container maxWidth={false} sx={{ px: 3 }}>
                    <Box className="d-flex justify-content-between pt-2">
                      <Typography variant="h5" className="fw-bold" sx={{ color: "#0d4022 !important", fontWeight: "bold" }}>
                        Rejection Reason
                      </Typography>
                      <IconButton onClick={handleClose} aria-label="Close">
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </Container>
                  <Box display="flex" justifyContent="center" width="100%" className='mb-2'>
                    <Divider sx={{ bgcolor: "black", height: "2px", width: '100%', marginTop: "-15px" }} />
                  </Box>
                  <Typography
                    id="modal-modal-title"
                    style={{ color: "#611f1e" }}
                    className="w-100"
                    variant="h6"
                    component="h2"
                  >
                    {memberRejected?.rejectionReason}
                  </Typography>
                </Box>
              </Modal>
            </Box>}
            {value === 3 && <Box sx={{ width: "100%" }} className="mt-3">
              <Paper sx={{ width: "100%", mb: 2 }}>
                <TableContainer>
                  <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle">
                    <EnhancedTableHead />
                    <TableBody>
                      {notPaid.length > 0 ? (
                        notPaid.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell align="center">{row.userId}</TableCell>
                            <TableCell align="center">
                              {row.fullName || row.organisationName || row.institution || "---"}
                            </TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">{row.mobileNumber}</TableCell>
                            <TableCell align="center">
                              {row.chapter?.length > 0 ? (
                                <ChapterName id={row.chapter} />
                              ) : (
                                <p className="text-dark">---</p>
                              )}
                            </TableCell>
                            <TableCell align="center">
                              {row.sigGroups?.length > 0 ? (
                                row.sigGroups.map((sig, index) => (
                                  <span key={index}>
                                    <SigName id={sig} />
                                    {index < row.sigGroups.length - 1 && <br />}
                                  </span>
                                ))
                              ) : (
                                <p className="text-dark">---</p>
                              )}
                            </TableCell>
                            {/* <TableCell align="center">
                              {row.address}, {row.city}, {row.pinCode}.
                            </TableCell> */}
                            <TableCell align="center">
                              <IconButton onClick={() => handleView(row)}>
                                <Tooltip title="View" placement="left">
                                  <VisibilityIcon style={{ color: '#ff8000' }} />
                                </Tooltip>
                              </IconButton>
                              <IconButton onClick={() => handleOpenForm(row)}>
                                <Tooltip title="Add Member" placement="right">
                                  <PersonAddAltOutlinedIcon style={{ color: 'green' }} />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            Will Be Added Shortly
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

              </Paper>
              {notPaid.length > 0 ? (
                <div className="d-flex justify-content-between flex-lg-row flex-column gx-3 gx-lg-0" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px", marginBottom: "56px" }}>
                  <div className="mb-2 mb-md-0">
                    <div className="d-flex gap-2">
                      <input
                        type="number"
                        placeholder="Page no."
                        value={searchTerm}
                        // onChange={(e) => setSearchTerm(e.target.value)}
                        // onChange={(e) => setSearchTerm(Number(e.target.value - 1))}
                        onChange={(e) => {
                          const page = e.target.value ? Math.max(1, Number(e.target.value)) : "";
                          setSearchTerm(page);
                        }}
                        min={1}
                        className="search-input"
                      />
                      <div className="goPage cursor-pointer" onClick={handlePageChange}>
                        <h5 className="p-2 m-0">Go</h5>
                      </div>
                    </div>
                    {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
                  </div>
                  <div className="my-3 my-lg-0">
                    <ReactPaginate
                      pageCount={NotPaidPageCount}
                      pageRangeDisplayed={1}
                      marginPagesDisplayed={1}
                      onPageChange={handleNotPaidPageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                      disabledClassName="disablebtn"
                      forcePage={notPaidMemberPage}
                      previousLabel={NotPaidPageCount > 1 && notPaidMemberPage >= 1 ? "Previous" : null}
                      nextLabel={NotPaidPageCount > 1 && notPaidMemberPage + 1 !== NotPaidPageCount ? "Next" : null}
                    />
                  </div>
                  <div className="mb-2 mb-md-0">
                    <FormControl variant="outlined">
                      <Select
                        value={itemsPerPage}
                        className="itemsperpage"
                        onChange={(e) => {
                          const value = e.target.value;
                          setItemsPerPage(value);
                          setError('')
                          setSearchTerm('');
                          setPage(0)
                        }}
                      >
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
              ) : (<></>)}
              {/* <Modal
                    open={open1}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box sx={style} className="d-flex align-items-center flex-column gap-3">
                      <h4 style={{ color: "#104e29" }}>Add Member Form</h4>

                      <form onSubmit={handleSubmit(AddMember)}>
                         

                      </form>
                      <Button
                        variant="outlined"
                        style={{
                          color: "red",
                          border: "1px solid red",
                          padding: "5px 15px",
                          borderRadius: "0px",
                        }}
                        onClick={handleClose}
                      >
                        Close
                      </Button>
                    </Box>
                  </Modal> */}
            </Box>}
            <Modal
              open={openChangeForm}
              onClose={handleChangeFormClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="d-flex w-100 align-items-center flex-column gap-3">
                <h4 className="alata-regular fs-3 title-font" style={{ color: "#104e29" }}>Change Plan</h4>
                <form className="w-100 d-flex flex-column justify-content-between h-100" onSubmit={handleSubmitChange(changePlan)}>
                  <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} md={6} lg={12} className="d-flex">
                      <span className="alata-regular fw-medium">Plan Name: &nbsp;</span>
                      <span className="alata-regular">{watchChange('planId') && <GetPlanDetails id={watchChange('planId')._id} value={'plan'} />}</span>
                    </Grid>
                    <Grid item xs={12} md={6} lg={12} className="d-flex">
                      <FormControl
                        // className="mt-0"
                        fullWidth
                        error={!!errorsChange.planType}
                      >
                        <InputLabel
                          htmlFor="planType"
                          className="text-dark" // Ensure that the label is associated with the input
                        >
                          Plan Type {" "}
                          <span style={{ color: "red" }}>*</span>
                        </InputLabel>
                        <Controller
                          name="planType"
                          control={controlChange}
                          rules={{
                            required: "Please select a membership plan type",
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              label="Membership plan type"
                              className="bg-white"
                              id="planType"
                              onChange={(e) => {
                                field.onChange(e); // Update field value
                                const planType = changePlanType.find((plan) => plan._id === e.target.value);
                                const amount = planType?.offer === 0 ? planType?.amount : planType?.offerAmount;
                                const planExpired = new Date().setHours(0, 0, 0, 0) > new Date(selectedMember?.plans.findLast(pl => pl.isPaid === 1)?.planEndDate)
                                if (planExpired) {
                                  setValueChange('amount', amount, { shouldDirty: false, shouldValidate: true })
                                }
                                else {
                                  setValueChange('amount', amount - (selectedMember?.plans.findLast(pl => pl.isPaid === 1).amount), { shouldDirty: false, shouldValidate: true })
                                }
                                setValueChange('currency', planType?.currency, { shouldDirty: false, shouldValidate: true })
                              }}
                              value={field.value || ""}
                            >
                              <MenuItem value="">
                                <em>Select a membership plan </em>
                              </MenuItem>
                              {changePlanType &&
                                changePlanType.map((plan) => (
                                  <MenuItem key={plan._id} value={plan._id}>
                                    <span>
                                      {plan.planTypeName} ({(plan.planTypeName === ('Annual Plan' || 'Annual')) ? 'Only For New Members' : plan.duration + (plan.duration > 1 ? ' Years' : ' Year')})
                                      {plan.offer === 0 ? (
                                        <span className="mx-2">
                                          {(plan?.currency === 1 ? "$" : "₹") +
                                            plan.amount}
                                        </span>
                                      ) : (
                                        <>
                                          <span className="text-decoration-line-through mx-2">
                                            {(plan?.currency === 1 ? "$" : "₹") +
                                              plan.amount}
                                          </span>
                                          <span>
                                            {(plan?.currency === 1 ? "$" : "₹") +
                                              plan.offerAmount}
                                          </span>
                                          <span className="ms-2">
                                            ({plan.offer + '% off '})
                                          </span>
                                        </>
                                      )}
                                    </span>
                                  </MenuItem>
                                ))}
                            </Select>
                          )}
                        />
                        {errorsChange.planType && (
                          <FormHelperText>
                            {errorsChange.planType.message}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        type="number"
                        label={
                          <Typography className="text-dark">
                            Amount ({watchChange('currency') === 1 ? "$" : "₹"}) <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        InputLabelProps={{ shrink: true }}
                        {...registerChange("amount", {
                          required: "Please enter amount",
                          valueAsNumber: true,
                          min: { value: 1, message: 'Amount should be greater than 0' },
                        })}
                        error={!!errorsChange?.amount}
                        helperText={errorsChange?.amount?.message}
                      />
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                      <Controller
                        control={controlChange}
                        rules={{ required: "Please select a payment type" }}
                        name="paymentType"
                        render={({ field }) => (
                          <FormControl fullWidth error={!!errorsChange.paymentType}>
                            <InputLabel id="paymentType-label" className="text-dark" >
                              Payment Type <span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <Select
                              {...field}
                              labelId="paymentType-label"
                              id="paymentType"
                              label='Payment Type *'
                              variant="outlined"
                              onChange={(e) => {
                                field.onChange(e.target.value)
                                setValueChange('bankTransactionId', '')
                                clearErrorChange()
                              }}
                            >
                              <MenuItem value="0">Cash</MenuItem>
                              <MenuItem value="1">Online</MenuItem>
                              <MenuItem value="2">Cheque</MenuItem>
                            </Select>
                            <FormHelperText>{errorsChange?.paymentType?.message}</FormHelperText>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    {watchChange('paymentType') === "2" && <Grid item xs={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        label={
                          <Typography className="text-dark">
                            Cheque ID <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        {...registerChange("bankTransactionId", {
                          required: watchChange('paymentType') === "2" ? "Please enter Cheque ID" : false,
                        })}
                        error={!!errorsAdd.bankTransactionId}
                        helperText={errorsAdd?.bankTransactionId?.message}
                      />
                    </Grid>}
                    {watchChange('paymentType') === "1" &&
                      <>
                        <Grid item xs={12} md={6} lg={6}>
                          <Controller
                            control={controlChange}
                            rules={{ required: "Please select a payment method" }}
                            name="paymentMethod"
                            render={({ field }) => (
                              <FormControl fullWidth error={!!errorsChange.paymentMethod}>
                                <InputLabel id="paymentMethod-label" variant="outlined">
                                  Payment Method <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Select
                                  {...field}
                                  labelId="paymentMethod-label"
                                  id="paymentMethod"
                                  label='Payment Method *'
                                  onChange={(e) => field.onChange(e.target.value)}
                                  variant="outlined"
                                >
                                  <MenuItem value="upi">UPI</MenuItem>
                                  <MenuItem value="netbanking">Net Banking</MenuItem>
                                  <MenuItem value="card">Card</MenuItem>
                                </Select>
                                <FormHelperText>{errorsChange?.paymentMethod?.message}</FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>
                        {watchChange('paymentMethod') !== 'card' && <Grid item xs={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            label={
                              <Typography className="text-dark">
                                Transaction ID <span style={{ color: "red" }}>*</span>
                              </Typography>
                            }
                            {...registerChange("bankTransactionId", {
                              required: watchChange('paymentMethod') !== "card" ? "Please enter Transaction ID" : false,
                            })}
                            error={!!errorsChange.bankTransactionId}
                            helperText={errorsChange?.bankTransactionId?.message}
                          />
                        </Grid>}
                      </>
                    }
                  </Grid>
                  <div className="d-flex gap-3 justify-content-center mt-3 pb-3">
                    <Button
                      variant="outlined"
                      color="error"
                      className="rounded-0"
                      onClick={handleChangeFormClose}
                    >
                      cancel
                    </Button>
                    <Button
                      variant="contained"
                      className="menus-color"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>

                </form>

              </Box>
            </Modal>
            <Modal
              open={openForm}
              onClose={handleFormClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="d-flex w-100 align-items-center flex-column gap-3">
                <h4 className="alata-regular fs-3 title-font" style={{ color: "#104e29" }}>{value === 0 ? 'Renew Member' : 'Add Member'}</h4>

                <form className="w-100 d-flex flex-column justify-content-between h-100" onSubmit={handleSubmitAdd(value === 0 ? renewMember : AddMember)}>
                  <Grid container rowSpacing={2} columnSpacing={3}>
                    <Grid item xs={12} md={6} lg={12} className="d-flex">
                      <span className="alata-regular fw-medium">Plan Name: &nbsp;</span>
                      <span className="alata-regular">{watchAdd('membershipPlan') && <GetPlanDetails id={watchAdd('membershipPlan')} typeId={watchAdd('membershipPlanType')} value={'plan'} />}</span>
                    </Grid>
                    <Grid item xs={12} md={6} lg={12} className="d-flex">
                      <span className="alata-regular fw-medium">Plan Type:&nbsp; </span>
                      <span className="alata-regular">{watchAdd('membershipPlanType') && <GetPlanDetails id={watchAdd('membershipPlan')} typeId={watchAdd('membershipPlanType')} value={'planType'} />}</span>
                    </Grid>
                    <Grid item xs={12} md={12} lg={12}>
                      <TextField
                        fullWidth
                        type="number"
                        InputLabelProps={{ shrink: true }}
                        label={
                          <Typography className="text-dark">
                            Amount ({watchAdd('currency') === "0" ? "₹" : "$"}) <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        {...registerAdd("amount", {
                          required: "Please enter amount",
                          valueAsNumber: true,
                          min: { value: 1, message: 'Amount should be greater than 0' },
                        })}
                        error={!!errorsAdd?.amount}
                        helperText={errorsAdd?.amount?.message}
                      />
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                      <Controller
                        control={controlAdd}
                        rules={{ required: "Please select a payment type" }}
                        name="paymentType"
                        render={({ field }) => (
                          <FormControl fullWidth error={!!errorsAdd.paymentType}>
                            <InputLabel id="paymentType-label" className="text-dark" >
                              Payment Type <span style={{ color: "red" }}>*</span>
                            </InputLabel>
                            <Select
                              {...field}
                              labelId="paymentType-label"
                              id="paymentType"
                              label='Payment Type *'
                              variant="outlined"
                              onChange={(e) => {
                                field.onChange(e.target.value)
                                setValueAdd('bankTransactionId', '')
                                nonPaidClearError()
                              }}
                            >
                              <MenuItem value="0">Cash</MenuItem>
                              <MenuItem value="1">Online</MenuItem>
                              <MenuItem value="2">Cheque</MenuItem>
                            </Select>
                            <FormHelperText>{errorsAdd?.paymentType?.message}</FormHelperText>
                          </FormControl>
                        )}
                      />
                    </Grid>
                    {watchAdd('paymentType') === "2" && <Grid item xs={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        label={
                          <Typography className="text-dark">
                            Cheque ID <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        {...registerAdd("bankTransactionId", {
                          required: watchAdd('paymentType') === "2" ? "Please enter Cheque ID" : false,
                        })}
                        error={!!errorsAdd.bankTransactionId}
                        helperText={errorsAdd?.bankTransactionId?.message}
                      />
                    </Grid>}
                    {watchAdd('paymentType') === "1" &&
                      <>
                        <Grid item xs={12} md={6} lg={6}>
                          <Controller
                            control={controlAdd}
                            rules={{ required: "Please select a payment method" }}
                            name="paymentMethod"
                            render={({ field }) => (
                              <FormControl fullWidth error={!!errorsAdd.paymentMethod}>
                                <InputLabel id="paymentMethod-label" variant="outlined">
                                  Payment Method <span style={{ color: "red" }}>*</span>
                                </InputLabel>
                                <Select
                                  {...field}
                                  labelId="paymentMethod-label"
                                  id="paymentMethod"
                                  label='Payment Method *'
                                  onChange={(e) => field.onChange(e.target.value)}
                                  variant="outlined"
                                >
                                  <MenuItem value="upi">UPI</MenuItem>
                                  <MenuItem value="netbanking">Net Banking</MenuItem>
                                  <MenuItem value="card">Card</MenuItem>
                                </Select>
                                <FormHelperText>{errorsAdd?.paymentMethod?.message}</FormHelperText>
                              </FormControl>
                            )}
                          />
                        </Grid>
                        {watchAdd('paymentMethod') !== 'card' && <Grid item xs={12} md={6} lg={6}>
                          <TextField
                            fullWidth
                            label={
                              <Typography className="text-dark">
                                Transaction ID <span style={{ color: "red" }}>*</span>
                              </Typography>
                            }
                            {...registerAdd("bankTransactionId", {
                              required: watchAdd('paymentMethod') !== "card" ? "Please enter Transaction ID" : false,
                            })}
                            error={!!errorsAdd.bankTransactionId}
                            helperText={errorsAdd?.bankTransactionId?.message}
                          />
                        </Grid>}
                      </>
                    }
                  </Grid>
                  <div className="d-flex gap-3 justify-content-center mt-3 pb-3">
                    <Button
                      variant="outlined"
                      color="error"
                      className="rounded-0"
                      onClick={handleFormClose}
                    >
                      cancel
                    </Button>
                    <Button
                      variant="contained"
                      className="menus-color"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>

                </form>

              </Box>
            </Modal>
          </>
        )}
      </Container>
    </>
  );
}
